function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.997 39.97a19.984 19.984 0 1114.118-5.85 19.937 19.937 0 01-14.118 5.85zm0-39.215a19.2 19.2 0 1013.585 5.616A19.153 19.153 0 0019.997.755zm-.392 27.451h-7.843v-7.843h.784v7.059h7.06v.784zm-4.157-3.137l-.549-.55 9.647-9.646.557.556-9.655 9.64zm12.785-5.49h-.785v-7.06H20.39v-.784h7.843v7.844z",
  fillRule: "nonzero"
});
function SvgMoreViews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgMoreViews;